<template>
  <div
      class="table-defaultInput"
      style="display: grid; flex-direction: column; position: relative;"
  >
    <input
        v-model="item.values"
        :class="`${item.class}${item.error === true ? ' error' : ''}`"
        :disabled="item.disabled"
        :maxlength="item.maxLength"
    />
    <span
        v-show="item.error === true && item.description !== undefined"
        :class="'description red'"
    >
      {{item.description}}
    </span>
    <span
        v-show="!item.disabled && (item.error === undefined || item.error === false)"
        class="input_length"
    >
      {{isContentsValid}}/{{item.maxLength}}
      <span v-show="item.unit">
        {{item.unit}}
      </span>
    </span>
  </div>
</template>
<script>
    export default {
      components: {},
      props: [ 'item' ],
      methods: {
        // maxLengthCheck(){
        //   if (this.getByte(this.item?.values) > this.item.maxLength){
        //     this.item.values = this.item.values.slice(0, this.item.maxLength);
        //   }
        // },
        // getByte(str) {
        //   return str.split('').map(s => s.charCodeAt(0)).reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0);
        // }
      },
      computed: {
        isContentsValid() {
          return this.item?.values ? this.item.values.length : 0
        }
      }
    }

</script>
<style lang="scss">
.input_length {
  font-size: 11px;
  color: var(--grey50);
  position: absolute;
  bottom: 1px;
  right: 1px;
}

.table-defaultInput {
  input:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }

  .error:focus {
    border: 1px solid var(--error20) !important;
  }
}
</style>